// src/languageContext.jsx
import React, { createContext, useState, useContext, useEffect } from 'react';
import { translations } from './translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('souqi_lang') || 'fr');

  useEffect(() => {
    localStorage.setItem('souqi_lang', language);
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    
    if (language === 'ar') {
      document.body.classList.add('font-arabic');
      document.body.classList.remove('font-sans');
    } else {
      document.body.classList.add('font-sans');
      document.body.classList.remove('font-arabic');
    }
  }, [language]);

  // On récupère l'objet de traduction actuel
  const currentTranslations = translations[language] || translations['fr'];

  // 1. On crée la fonction de base
  const t = (key) => {
    return currentTranslations[key] || key;
  };

  // 2. MAGIE : On injecte les clés de traduction directement dans la fonction
  // Cela permet de faire t.maCle ET t("maCle")
  Object.assign(t, currentTranslations);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
